import type { ReactNode } from "react";
import { cn } from "@tellescope/ui";

interface EntryRowProps {
  icon: ReactNode;
  title: ReactNode;
  meta: string;
  value?: string;
  isSelected?: boolean;
  onClick?: () => void;
  actions?: ReactNode;
}

export const EntryRow = ({ icon, title, meta, value, isSelected, onClick, actions }: EntryRowProps) => (
  <div
    className={cn(
      "w-full flex items-center justify-between gap-3 px-3 py-2.5 transition-colors",
      onClick && "cursor-pointer",
      isSelected ? "bg-muted" : "hover:bg-muted/60"
    )}
    onClick={onClick}
  >
    <div className="flex items-center gap-3 min-w-0">
      <div className="flex items-center justify-center w-8 h-8 rounded-md bg-muted text-muted-foreground shrink-0">
        {icon}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium truncate">{title}</p>
        <p className="text-xs text-muted-foreground">{meta}</p>
      </div>
    </div>
    <div className="flex items-center gap-2 shrink-0">
      {value && <span className="text-sm font-medium tabular-nums">{value}</span>}
      {actions}
    </div>
  </div>
);
